export default __webpack_public_path__ + "static/media/explainer.abd6f542.mp3";